import { render, staticRenderFns } from "./FilterSearchByVideoResults.vue?vue&type=template&id=dd0ddd12"
import script from "./FilterSearchByVideoResults.vue?vue&type=script&lang=js"
export * from "./FilterSearchByVideoResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports